/**
 * Animates a numeric element from 0 to its target value.
 * @param {HTMLElement} el - Element with data-countup attribute containing the target value
 */
export const countUp = (el) => {
  if (el.dataset.counting === 'true') return
  el.dataset.counting = 'true'
  
  const rawValue = el.dataset.countup
  const numericValue = parseFloat(rawValue)
  const hasDecimal = rawValue.includes('.')
  const decimals = hasDecimal ? rawValue.split('.')[1].length : 0
  const duration = 1500
  const startTime = performance.now()

  const tick = (now) => {
    const progress = Math.min((now - startTime) / duration, 1)
    // Ease-out cubic for a natural deceleration
    const eased = 1 - Math.pow(1 - progress, 3)
    el.textContent = (numericValue * eased).toFixed(decimals)

    if (progress < 1) {
      requestAnimationFrame(tick)
    } else {
      // Snap to exact value to avoid floating-point display artifacts
      el.textContent = rawValue
    }
  }

  requestAnimationFrame(tick)
}

/**
 * Initialises scroll-triggered animations for all fact cards.
 * Numeric facts count up from 0; string facts simply fade in.
 * Both transitions are staggered within each row of three.
 */
export const initializeFacts = () => {
  const cards = document.querySelectorAll('[data-scroll-card]')
  if (!cards.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        const card = entry.target
        const delay = parseInt(card.dataset.stagger ?? '0', 10)

        setTimeout(() => {
          // Reveal the card (removes the initial hidden state set via inline style)
          card.style.opacity = '1'
          card.style.transform = 'translateY(0)'

          // Trigger count-up for numeric facts
          const countEl = card.querySelector('[data-countup]')
          if (countEl) {
            countUp(countEl)
          }
        }, delay)

        // Only animate once
        observer.unobserve(card)
      })
    },
    { threshold: 0 }
  )

  cards.forEach((card) => observer.observe(card))
}
